import * as types from '../../../constants/ActionTypes';

export const setDrawerOpened = drawerOpened => ({
    type: types.SET_DRAWER_OPENED,
    drawerOpened,
});



// WEBPACK FOOTER //
// ./src/app/FormStepper/Drawer/drawerActions.js